<template>
  <li v-editable="blok" class="flex gap-5">
    <NuxtLazyImage
      :key="blok.icon.filename"
      :source="blok.icon.filename"
      :alt="blok.icon.alt ?? undefined"
      :title="blok.icon.title ?? undefined"
      no-scale
      class="size-12"
    />
    <span class="flex flex-col justify-center">{{ blok.text }}</span>
  </li>
</template>

<script lang="ts">
import type { SbFeature } from '~/cms/storyblok/types/storyblok.d.ts'
import NuxtLazyImage from '~/components/images/NuxtLazyImage.vue'

export default defineComponent({
  name: 'Feature',
  components: { NuxtLazyImage },
  props: {
    blok: {
      type: Object as PropType<SbFeature>,
      required: true,
    },
  },
})
</script>
